/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t,s,i,e,h,o=!1,r=0,n=!1){this.name=t,this.count=s,this.type=i,this.offset=e,this.stride=h,this.normalized=o,this.divisor=r,this.integer=n}}export{t as VertexElementDescriptor};
